"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 3: CNROM
 * ------------------------------------------------------------------ */
// CNROM

function register(Mappers) {
  Mappers[3] = function (nes) {
    this.nes = nes;
    this.currentVromBank = 0;
  };

  /* ------------------------------------------------------------------ *
   * Mapper 3: CNROM
   * ------------------------------------------------------------------ *
   * Very simple mapper:
   * - PRG ROM: 32 KB fixed at $8000 (no banking, or 16 KB mirrored).
   * - CHR ROM: 8 KB switchable at $0000 via write to $8000-$FFFF.
   * - Mirroring: Hardwired (usually vertical).
   * - Optional IRQ counter at $FF00 (some CNROM boards like CNROM-256).
   * - Bankswitching: write to $8000-$FFFF (except $FF00) selects 8 KB CHR bank.
   */

  Mappers[3].prototype = new Mappers[0]();
  // CNROM counts A12 rises, not scanlines.
  Mappers[3].prototype.irqClockRate = "a12";

  Mappers[3].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.currentVromBank = 0;
    this.irqCounter = 0;
    this.irqLatch = 0;
    this.irqEnabled = false;
  };

  Mappers[3].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // $FF00 is the optional scanline counter (on boards that have it),
    // everything else is a CHR bank select.
    if (address === 0xff00) {
      this.writeIrq(value);
      return;
    }

    // The register is 2 to 5 bits wide depending on the CHR size.
    // Standard CNROM: 2 bits (4 banks of 8 KB = 32 KB CHR).
    // Extended CNROM: up to 5 bits (32 banks of 8 KB = 256 KB CHR).
    // The iNES header byte 5 gives the number of 8 KB CHR banks.
    // Standard CNROM has 4 banks (header[5] = 4). Extended has >4.
    var num8kBanks = this.nes.rom.header[5];
    var bank = value & 0x03;
    if (num8kBanks > 4) {
      bank = value & 0x1f;
    }
    this.currentVromBank = bank;
    // Load 8 KB CHR bank (two 4 KB pages) at $0000.
    this.load8kVromBank(bank * 2, 0x0000);
  };

  Mappers[3].prototype.writeIrq = function (value) {
    switch (value & 3) {
      case 0:
        // Disable, acknowledge any pending IRQ.
        this.irqEnabled = false;
        this.irqCounter = 0;
        break;
      case 1:
        // Reload the latch (but don't start counting yet).
        this.irqCounter = this.irqLatch;
        break;
      case 2:
        // Reload the latch and enable IRQ.
        this.irqCounter = this.irqLatch;
        this.irqEnabled = true;
        break;
      case 3:
        // Enable IRQ with current counter value.
        this.irqEnabled = true;
        break;
    }
  };

  Mappers[3].prototype.clockIrqCounter = function () {
    if (!this.irqEnabled || this.irqCounter === 0) {
      return;
    }
    this.irqCounter--;
    if (this.irqCounter === 0) {
      this.irqEnabled = false;
      this.nes.cpu.requestIrq(this.nes.cpu.IRQ_NORMAL);
    }
  };

  Mappers[3].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("CNROM: Invalid ROM! Unable to load.");
    }

    this.reset();
    // PRG ROM is 32 KB fixed at $8000 (or 16 KB mirrored if only 1 bank).
    if (this.nes.rom.romCount > 1) {
      this.loadRomBank(0, 0x8000);
      this.loadRomBank(this.nes.rom.romCount - 1, 0xc000);
    } else {
      this.loadRomBank(0, 0x8000);
      this.loadRomBank(0, 0xc000);
    }
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };

  Mappers[3].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.currentVromBank = this.currentVromBank;
    s.irqCounter = this.irqCounter;
    s.irqLatch = this.irqLatch;
    s.irqEnabled = this.irqEnabled;
    return s;
  };

  Mappers[3].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.currentVromBank = s.currentVromBank;
    this.irqCounter = s.irqCounter;
    this.irqLatch = s.irqLatch;
    this.irqEnabled = s.irqEnabled;
  };
}

module.exports = { register: register };
